"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Textarea = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _autosize = _interopRequireDefault(require("autosize"));

var _Textarea = require("./Textarea.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const isFunction = x => typeof x === 'function';

const Textarea = /*#__PURE__*/_react.default.forwardRef(({
  textareaProps,
  errorProps,
  label,
  className: containerClassName,
  error,
  errorMessage,
  width,
  showEditButton,
  onEditButtonClick,
  disabled,
  ...containerPropsRest
}, ref) => {
  const [isFocused, setFocus] = (0, _react.useState)(false);
  let tRef = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    if (tRef && tRef.current || ref && ref.current) {
      (0, _autosize.default)(tRef.current || ref.current);
    }
  }, [tRef, ref]);

  const handleBlur = event => {
    setFocus(false);

    if (isFunction(textareaProps.onBlur)) {
      textareaProps.onBlur(event);
    }
  };

  const handleFocus = event => {
    setFocus(true);

    if (isFunction(textareaProps.onFocus)) {
      textareaProps.onFocus(event);
    }
  };

  const {
    className: inputClassName,
    placeholder,
    boxed,
    limit,
    value = '',
    ...textareaPropsRest
  } = textareaProps || {};

  const editButtonClickHandler = e => {
    onEditButtonClick && isFunction(onEditButtonClick) && onEditButtonClick(e);
  };

  return /*#__PURE__*/_react.default.createElement(_Textarea.StyledTextareaComponent, {
    className: containerClassName,
    width: width
  }, /*#__PURE__*/_react.default.createElement(_Textarea.StyledTextareaContainer, _extends({
    className: (0, _classnames.default)({
      container_error: error,
      container_focus: isFocused || showEditButton,
      boxed: boxed,
      filled: value.length,
      disabled: disabled
    })
  }, containerPropsRest), /*#__PURE__*/_react.default.createElement("label", {
    className: "textarea_parent"
  }, label ? /*#__PURE__*/_react.default.createElement("span", {
    className: "textarea__label"
  }, label) :
  /*#__PURE__*/
  // Used for ADA compliance
  _react.default.createElement("span", {
    className: "textarea__label--hidden"
  }, placeholder), /*#__PURE__*/_react.default.createElement(_Textarea.StyledMultiline, {
    className: (0, _classnames.default)({
      [`has-content`]: value.length > 0,
      parent: true,
      ['has-edit']: showEditButton
    }),
    isFocused: isFocused,
    hasContent: value.length > 0
  }, /*#__PURE__*/_react.default.createElement("textarea", _extends({
    placeholder: placeholder,
    onBlur: handleBlur,
    onFocus: handleFocus,
    className: inputClassName,
    maxLength: limit,
    value: value,
    ref: ref || tRef,
    rows: 1
  }, textareaPropsRest)), showEditButton && /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-text-button",
    onClick: editButtonClickHandler
  }, "Edit"), limit && /*#__PURE__*/_react.default.createElement("span", {
    className: "limit"
  }, /*#__PURE__*/_react.default.createElement("span", null, value.length), /*#__PURE__*/_react.default.createElement("span", null, "/", limit))))), error && errorMessage && /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "error"
  }, errorProps), errorMessage));
});

exports.Textarea = Textarea;
Textarea.propTypes = {
  /** expect true/false, if field has error */
  error: _propTypes.default.bool,
  errorMessage: _propTypes.default.string,
  label: _propTypes.default.string,
  iconLeft: _propTypes.default.string,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  textareaProps: _propTypes.default.shape({
    defaultValue: _propTypes.default.string,
    onBlur: _propTypes.default.func,
    onFocus: _propTypes.default.func,
    onChange: _propTypes.default.func,
    type: _propTypes.default.string,
    value: _propTypes.default.string,
    placeholder: _propTypes.default.string
  }),

  /** errorProps are used to pass extra param like data-testid */
  errorProps: _propTypes.default.object,

  /** width should be given with unit. eg: 100px */
  width: _propTypes.default.string,
  limit: _propTypes.default.number,

  /** Show/Hide edit button */
  showEditButton: _propTypes.default.bool,

  /** Edit button callback*/
  onEditButtonClick: _propTypes.default.func
};